import { useContext } from 'react';

import CombinedNotificationsContext from './context';

const useCombinedNotificationsContext = () => useContext(CombinedNotificationsContext);

export default useCombinedNotificationsContext;
